export default "__VITE_ASSET__VKZtRpub__"